import styled from "styled-components";
import { FaWhatsapp as FaWhatsappIcon } from "react-icons/fa";
import { FaBars as FaBarsIcon, FaTimes as FaTimesIcon } from "react-icons/fa";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const WhatsApp = FaWhatsappIcon as unknown as React.FC<{ size?: number }>;
const Bars = FaBarsIcon as unknown as React.FC<{ size?: number }>;
const Close = FaTimesIcon as unknown as React.FC<{ size?: number }>;

const Nav = styled.nav`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 3rem;
    background: white;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 1000;

    @media (max-width: 768px) {
        padding: 0.5rem 1.5rem;
    }
`;

const Logo = styled.h1`
    font-size: 1.4rem;
    color: #0077b6;

    @media (max-width: 768px) {
        font-size: 1.2rem;
    }
`;

const NavLinks = styled.div<{ isOpen: boolean }>`
    display: flex;
    gap: 1.5rem;

    @media (max-width: 768px) {
        display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
        flex-direction: column;
        position: absolute;
        top: 100%;
        right: ${({ isOpen }) => (isOpen ? "0" : "-100%")};
        background: white;
        width: 100%;
        padding: 1rem;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
        transition: right 0.3s ease-in-out;
    }
`;

const NavLink = styled.a`
    color: #333;
    font-weight: 500;
    cursor: pointer;

    &:hover {
        color: #0077b6;
    }

    @media (max-width: 768px) {
        padding: 0.5rem 0;
        text-align: center;
    }
`;

const LangSwitch = styled.button`
    margin-left: 1rem;
    border: none;
    background: transparent;
    cursor: pointer;
    font-weight: bold;

    @media (max-width: 768px) {
        margin-left: 0;
    }
`;

const Hamburger = styled.div`
    display: none;
    cursor: pointer;

    @media (max-width: 768px) {
        display: block;
    }
`;

export const Navbar: React.FC = () => {
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const toggleLang = () =>
        i18n.changeLanguage(i18n.language === "en" ? "es" : "en");

    const toggleMenu = () => setIsOpen((prev) => !prev);

    return (
        <Nav>
            <Hamburger onClick={toggleMenu}>
                {isOpen ? <Close size={24} /> : <Bars size={24} />}
            </Hamburger>
            <Logo>Buenos Aires Trainer</Logo>
            <NavLinks isOpen={isOpen}>
                <NavLink href="#services" onClick={() => setIsOpen(false)}>
                    {t("nav.services")}
                </NavLink>
                <NavLink href="#about" onClick={() => setIsOpen(false)}>
                    {t("nav.about")}
                </NavLink>
                <NavLink href="#testimonials" onClick={() => setIsOpen(false)}>
                    {t("nav.stories")}
                </NavLink>
                <NavLink href="#contact" onClick={() => setIsOpen(false)}>
                    {t("nav.contact")}
                </NavLink>
                <LangSwitch onClick={toggleLang}>
                    {i18n.language === "en" ? "ES" : "EN"}
                </LangSwitch>
            </NavLinks>
            <a
                href="https://wa.me/5491153224748"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#25D366" }}
            >
                <WhatsApp size={32} />
            </a>
        </Nav>
    );
};
